import { Component } from '@angular/core';
import { BaseModalDialogDirective } from '../../shared/directives/base-modal-dialog.directive';
import { ModalSize } from '../../shared/enums/modal-size.enum';
import { ModalCloseType } from '../../shared/components/modal/modal-close-type.enum';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss'],
  standalone: false,
})
export class ChangePasswordModalComponent extends BaseModalDialogDirective {
  get closeType(): ModalCloseType {
    return ModalCloseType.Safe;
  }

  get size(): ModalSize {
    return ModalSize.Small;
  }
}
